/**
 * Fiskal Cloud Admin ELSTER Registration API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EmailNotificationDetailDTO } from './email-notification-detail-dto';
import { ElsterContractChangeLogDTO } from './elster-contract-change-log-dto';


/**
 * Defines an elster contract body for update.
 */
export interface AdminElsterContractBodyDTO { 
    /**
     * Customer name used for the contract.
     */
    customerName?: string;
    contractChangeLog?: ElsterContractChangeLogDTO;
    notifications?: Array<EmailNotificationDetailDTO>;
}

export class ClsAdminElsterContractBodyDTO { 
    /**
     * Customer name used for the contract.
     */
    customerName?: string = undefined;
    contractChangeLog?: ElsterContractChangeLogDTO = undefined;
    notifications?: Array<EmailNotificationDetailDTO> = undefined;
}

